import { createFileRoute } from "@tanstack/react-router";

import { DevicesPage } from "../../../features/pos/devices-page";

export const Route = createFileRoute("/_app/pos/devices")({ component: DevicesPage });
